module.exports = __webpack_public_path__ + "static/media/im.ac0c825e.svg";